import { login } from "../../js/api/auth.js";
import TranslationService, { _t } from "../../services/TranslationService.js";
import {
  checkForUserGroup,
  transformRepeatBet,
} from "../../services/UserGroup.js";

let Login = {
  render: async () => {
    const accessToken = localStorage.getItem("access_token");

    let view = `
            <div class="${
              accessToken ? "hidden" : ""
            } fixed top-0 left-0 bg-[#585858] w-screen h-screen z-50">
                <div class="flex flex-wrap flex-row justify-center items-center w-full h-full">
                    <div class="flex flex-row flex-wrap w-full max-w-[360px] rounded-[2px] overflow-hidden bg-gradient-to-b from-[rgba(43,43,43,1)] to-[rgba(68,68,68,1)] shadow-[0px_3px_3px_#000000]">
                        <div class="flex flex-row flex-wrap items-center justify-center w-full bg-black mb-[10px] font-bold text-[14px] leading-[30px] text-white shadow-[0px_1px_1px_#000000]">
                            <span class="font-bold text-[14px] leading-[30px]">Identifikohu</span>
                        </div>
                        <div class="flex flex-row flex-wrap w-full space-y-3">
                            <div class="flex flex-row flex-wrap w-full space-x-2">
                                <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">Gjuha:</span>
                                <div class="flex flex-row flex-wrap flex-1 space-x-1">
                                    ${TranslationService.languages
                                      .map(
                                        (lang) => `
                                        <img src="~/../img/${lang.name.toLowerCase()}.png" class="cursor-pointer" data-lang="${
                                          lang.key
                                        }"/>
                                    `
                                      )
                                      .join("")}
                                </div>
                            </div>
                            <div class="flex flex-row flex-wrap w-full space-x-2">
                                <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">${_t(
                                  "Perdoruesi"
                                )}:</span>
                                <div class="flex flex-row flex-wrap flex-1">
                                    <input class="w-[150px] h-[24px] border-0 text-black rounded-[3px] bg-[#cccccc] shadow-[0px_1px_1px_1px_#000] px-2 text-[12px]" type="text" name="loginUsername" id="login-username">
                                </div>
                            </div>
                            <div class="flex flex-row flex-wrap w-full space-x-2">
                                <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">Fjalekalimi:</span>
                                <div class="flex flex-row flex-wrap flex-1">
                                    <input class="w-[150px] h-[24px] border-0 text-black rounded-[3px] bg-[#cccccc] shadow-[0px_1px_1px_1px_#000] px-2 text-[12px]" type="password" name="loginPassword" id="login-password">
                                </div>
                            </div>
                            <div class="flex flex-row flex-wrap w-full items-center justify-center">
                                <button class="loginAuthBtn bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)] text-white px-[10px] w-auto h-[30px] cursor-pointer leading-[30px] text-[12px]" id="loginAuthBtn">${_t(
                                  "Identifikohu"
                                )}</button>
                            </div>
                            <div class="flex flex-row flex-wrap w-full items-center justify-center">
                                <span class="errorDesc text-[8pt] mb-2 text-white"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    return view;
  },

  after_render: async () => {
    const loginBtn = document.getElementById("loginAuthBtn");
    const input = document.getElementById("login-password");

    if (loginBtn) {
      loginBtn.addEventListener("click", async () => {
        const username = document.getElementById("login-username").value;
        const password = document.getElementById("login-password").value;
        var loginResult = await login(username, password);
        console.log(loginResult);

        if (loginResult.user.role === "User") {
          if (loginResult && loginResult.jwt) {
            localStorage.setItem("user_id", loginResult.user.id);
            localStorage.setItem("access_token", loginResult.jwt);
            localStorage.setItem("name", loginResult.user.name);
            localStorage.setItem("surname", loginResult.user.surname);
            localStorage.setItem("role", loginResult.user.role);
            localStorage.setItem("slotId", loginResult.user.slot_id);
            localStorage.setItem("username", username);
            localStorage.setItem("chatToken", loginResult.user.chatToken);
            localStorage.setItem("slotEnabled", loginResult.user.slotEnabled);

            $("body").removeClass("modalIsShown");
            $("body .loginModal").removeClass("clicked");

            const userGroup = await checkForUserGroup();
            if (userGroup) {
              let games = JSON.parse(localStorage.getItem("addObject")) || [];
              if (games.length) {
                games = transformRepeatBet(games);
                localStorage.setItem("addObject", JSON.stringify(games));
              }
            }

            // Reload through the normal app bootstrap so blocked sports are
            // fetched before the desktop header, page, and left panel render.
            window.location.reload();
            return;
          }
        } else {
          if (loginResult.errors) {
            $("body .errorDesc").text(_t(loginResult.message));
          }
        }

        if (loginResult.errors) {
          $("body .errorDesc").text(_t(loginResult.message));
        }
      });
    }

    $(".loginModal input").on("keyup", function () {
      $("body .errorDesc").text("");
    });

    input.addEventListener("keyup", function (event) {
      if (event.keyCode === 13) {
        document.getElementById("loginAuthBtn").click();
      }
    });

    document.querySelectorAll("[data-lang]").forEach((langElement) => {
      langElement.addEventListener("click", (event) => {
        const newLang = event.target.getAttribute("data-lang");
        TranslationService.setLanguage(newLang);
        localStorage.setItem("lang", newLang);
      });
    });
  },
};

export default Login;
